module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }, [_c('b-message', {
    attrs: {
      "type": "is-info"
    }
  }, [_c('p', [_c('strong', [_vm._v("VeeValidate is not included in Buefy")]), _vm._v(", you have to install it:")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "code": "npm install vee-validate",
      "expanded": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://github.com/baianat/vee-validate",
      "target": "_blank"
    }
  }, [_vm._v("\n                Website\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://baianat.github.io/vee-validate",
      "target": "_blank"
    }
  }, [_vm._v("\n                Docs\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8d0a636"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/extensions/veevalidate/VeeValidate.vue
// module id = 1586
// module chunks = 41